import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-code_svg__a"
        d="M5.988 19.584c.308.329.812.494 1.511.494H9v2H7.803c-1.056 0-1.923-.12-2.602-.357-.679-.238-1.196-.647-1.553-1.228-.356-.581-.535-1.378-.535-2.392l.027-3.34c0-.678-.1-1.105-.304-1.367-.202-.263-.514-.394-.934-.394H1v-2h.882c.447 0 .778-.137.991-.41.213-.272.32-.67.32-1.264l-.049-3.454c0-1.273.35-2.237 1.044-2.891C4.884 2.327 5.908 2 7.258 2H9v1.997H6.89c-.46 0-.802.144-1.022.43-.22.287-.33.718-.33 1.29l.037 3.367c0 .63-.135 1.195-.404 1.695-.27.5-.646.905-1.128 1.212.447.286.807.699 1.081 1.239.272.538.41 1.146.41 1.825L5.525 18c0 .728.154 1.256.462 1.584zM22.118 11H23v2h-.903c-.419 0-.73.131-.933.394-.203.262-.305.689-.305 1.367l.028 3.34c0 1.014-.179 1.811-.536 2.392-.356.581-.874.99-1.552 1.228-.679.238-1.546.357-2.603.357H15v-2h1.501c.7 0 1.203-.165 1.511-.494.307-.328.461-.856.461-1.584l-.006-2.945c0-.679.136-1.287.41-1.826.272-.539.633-.952 1.08-1.238a3.225 3.225 0 01-1.128-1.212c-.27-.5-.404-1.065-.404-1.695l.038-3.366c0-.573-.11-1.004-.33-1.29-.22-.287-.563-.431-1.024-.431H15V2h1.742c1.35 0 2.373.327 3.07.981.695.654 1.043 1.618 1.043 2.891l-.049 3.454c0 .594.108.992.321 1.265.213.272.544.409.991.409zm-8.493-4.5l1.732 1-4.875 10-1.732-1 4.875-10z"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      xlinkHref="#icons-code_svg__a"
    />
  </svg>
);
